
export default {
  data: function () {
    return {
      value: "",
      blurValue: "",
      isFocus: false
    }
  },

  props: {
    initValue: {
      type: [String, Number],
      default: ""
    },

    minimal: {
      type: Number,
      default: 0
    },
    maximal: {
      type: Number,
      default: 0
    },

    type: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
  },

  watch: {
    initValue: function () {
      this.setInitValue();
    }
  },

  mounted: function () {
    this.setInitValue();
  },

  methods: {
    setInitValue: function () {
      let value = this.initValue;
      if (this.type === "min") {
        if (+value < +this.minimal || +value === +this.minimal) {
          value = ""
        }
      }
      if (this.type === "max") {
        if (+value > +this.maximal || +value === +this.maximal) {
          value = ""
        }
      }
      this.value = value;
    },

    onFocus: function () {
      this.blurValue = this.value;
      this.value = "";
      this.isFocus = true;
    },
    onInput: function ({ target }) {
      this.value = target.value || "";
    },
    onBlur: function () {
      let value = +this.value || +this.blurValue || +this.initValue;
      if (this.type === "min") {
        if (+value < +this.minimal || +value === +this.minimal) {
          value = ""
        }
      }
      if (this.type === "max") {
        if (+value > +this.maximal || +value === +this.maximal) {
          value = ""
        }
      }
      this.value = value;
      this.$emit("onChange", value);
      this.blurValue = "";
      this.isFocus = false;
    },
  }
}
